export default {
    title: 'Something went wrong 😢',
    description: "Don't worry! We've been notified, and we're working hard to fix it!",
    loginCancelled: 'Login cancelled',
    facebook: {
        sdkNotLoaded: 'Facebook SDK not loaded',
        sdkInitFailed: 'Failed to initialize Facebook SDK',
        loginCancelled: 'Login cancelled',
        loginFailed: 'Login failed',
        loginCanceled: 'Facebook login cancelled',
        permissionsRequired: {
            title: 'Permissions required',
            description: 'To link your account, you need to enable all the permissions requested by Facebook.',
            steps: {
                step1: "On the Facebook screen, click 'Manage settings'",
                step2: 'Turn on every permission listed',
                step3: 'Save and try linking your account again',
            },
        },
    },
    business: {
        noBusiness: 'Looks like there is not business linked to this account',
    },
};
